import { Crown, Star, Zap } from "lucide-react";

export const subscriptionTierMapper = (tier: "free" | "basic" | "pro") => {
  switch (tier) {
    case "free":
      return {
        title: "المجانية",
        icon: <Star className="size-8 text-primary" />,
      };
    case "basic":
      return {
        title: "المتقدمة",
        icon: <Zap className="size-8 text-yellow-600" />,
      };
    case "pro":
      return {
        title: "الإحترافية",
        icon: <Crown className="size-8 text-green-600"/>,
      };
    default:
      return {
        title: "المجانية",
        icon: <Star className="size-8 text-primary" />,
      };
  }
};
